import { AttributesSelector, Box, Select } from '@workwhile/ui'
import React, { useMemo } from 'react'
import type { ReverificationExpirationFilterDays } from '../../context/i9HubRows'

export const EXPIRATION_OPTIONS = [7, 14, 30, 60, 90] as const

export type ExpirationDays = (typeof EXPIRATION_OPTIONS)[number]
export type ExpirationDaysUrl = `${ExpirationDays}`

const expirationSelectOptions = EXPIRATION_OPTIONS.map((days) => ({
  label: `Within ${days} days`,
  value: String(days),
}))

type ExpirationWindowUrlFilterProps = {
  value: ReverificationExpirationFilterDays
  onChange: (days: ReverificationExpirationFilterDays) => void
}

export function ExpirationWindowUrlFilter({
  value,
  onChange,
}: ExpirationWindowUrlFilterProps) {
  const selectedAttributes = useMemo(() => [`Within ${value} days`], [value])

  return (
    <AttributesSelector
      label="Expiration"
      rootGroupTitle="Filter by"
      selectedAttributes={selectedAttributes}
      onClearAll={() => onChange(90)}
      groups={
        <AttributesSelector.Group
          key="expirationDays"
          title="Expiration"
          numberOfSelectedAttributes={selectedAttributes.length}
        >
          <Box>
            <Select
              options={expirationSelectOptions}
              placeholder="Select expiration window..."
              value={
                expirationSelectOptions.find(
                  (option) => option.value === String(value)
                ) ?? null
              }
              onChange={(option) => {
                if (option) {
                  onChange(
                    Number.parseInt(
                      option.value,
                      10
                    ) as ReverificationExpirationFilterDays
                  )
                }
              }}
            />
          </Box>
        </AttributesSelector.Group>
      }
    />
  )
}
